module.exports = __webpack_public_path__ + "static/media/covid_prevention.1f45d388.svg";